import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserService} from "../../../services/user.service";
import {ConfirmationToastComponent} from "../../../components/confirmation-toast/confirmation-toast.component";
import {DialogService} from "../../../services/dialog.service";
import {forkJoin, of} from "rxjs";

@Component({
  selector: 'app-edit-certifications',
  templateUrl: './edit-certifications.component.html',
  styleUrl: './edit-certifications.component.scss',
  standalone: false
})
export class EditCertificationsComponent {

  users: any[] = [];

  //certs
  NIS_BAER!: boolean;
  VGIS!: boolean;

  constructor(
    public dialogRef: MatDialogRef<EditCertificationsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly userService: UserService,
    private readonly toast: ConfirmationToastComponent,
    private readonly dialogService: DialogService,
  ) {
    dialogRef.disableClose = true;
    if (!Array.isArray(data.user)) {
      this.users = [data.user];
    } else {
      this.users = data.user;
    }
    this.NIS_BAER = false;
    this.VGIS = false;
  }

  apply() {
    const requests$ = this.users.map(user => this.userService.editUserDetails({
      user_id: user.user_id,
      NIS_BAER: this.NIS_BAER,
      VGIS: this.VGIS,
      procedure: 'REASSIGN'
    }));
    forkJoin(requests$).subscribe({
      next: () => {
        this.toast.openSuccessSnackBar(`GIS certifications have been updated for ${this.users.map(user => `${user.first_name} ${user.last_name}`).join(', ')}.`);
        this.dialogRef.close(true);
      }
    });
  }

  displayExistingCerts(user: any) {
    const certs: string[] = [];
    if (user.NIS_BAER) certs.push('NIS_BAER');
    if (user.VGIS) certs.push('VGIS');
    return certs.length > 0 ? ` (${certs.join(', ')})` : '';
  }
}
